import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faGlobe, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import './ProductAnalyzerModal.css';

// "Add products from a website": the owner pastes a shop/listing URL; the backend
// crawls it (sitemap + infinite scroll), extracts products, and opens the same
// analyzer confirm modal. Reuses the analyzer modal's shell styles (.pa-*).
const inputSx = {
  '& .MuiOutlinedInput-root': { borderRadius: '10px' },
  '& .MuiOutlinedInput-root.Mui-focused': { '& fieldset': { border: '1px solid #515151' } },
  '& .MuiInputLabel-root': { color: 'gray', '&.Mui-focused': { color: '#5616ea' } },
};

const AddProductWebsiteModal = ({ open, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const [url, setUrl] = useState('');

  if (!open) return null;

  const submit = () => {
    const u = url.trim();
    if (!u) return;
    onSubmit(u);
    setUrl('');
  };

  return (
    <div className="pa-modal">
      <div className="pa-overlay" onClick={onClose} />
      <div className="pa-content" style={{ maxWidth: '520px' }}>
        <div className="pa-header">
          <div className="pa-header-left">
            <span className="pa-header-ic"><FontAwesomeIcon icon={faGlobe} /></span>
            <span className="pa-header-text">
              <span className="pa-title">{t('aw_title')}</span>
              <span className="pa-subtitle">{t('aw_subtitle')}</span>
            </span>
          </div>
          <button className="pa-close" onClick={onClose} aria-label={t('close')}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <div className="pa-body">
          <div className="pa-field">
            <TextField
              label={t('aw_url_label')}
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
              placeholder="https://www.example.com"
              helperText={t('aw_url_hint')}
              fullWidth
              variant="outlined"
              size="small"
              autoFocus
              sx={inputSx}
            />
          </div>
        </div>

        <div className="pa-footer">
          <button className="pa-btn pa-btn-secondary" onClick={onClose}>{t('cancel')}</button>
          <button className="pa-btn pa-btn-primary" onClick={submit} disabled={!url.trim()}>
            <FontAwesomeIcon icon={faMagnifyingGlass} /> {t('aw_find')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddProductWebsiteModal;
